// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New theme setting */
.theme-setting-visual-editor .Polaris-FullscreenBar {
  z-index: 517;
}

.theme-setting-visual-editor .Polaris-Frame__Content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme-setting-visual-editor .visual-editor-header {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
}

.theme-setting-visual-editor .visual-editor-header .theme-name {
  display: flex;
  align-items: center;
  max-width: 335px;
}

.theme-setting-visual-editor .visual-editor-header .theme-name p {
  font-size: 14px;
  line-height: 20px;
}

.theme-setting-visual-editor .visual-editor-header .theme-name p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 85%;
}

.theme-setting-visual-editor .visual-editor-header .theme-name .Polaris-Badge {
  background: #a4e8f2;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-left: 8px;
}

.theme-setting-visual-editor .Polaris-FullscreenBar__BackAction {
  display: none;
}

.theme-setting-visual-editor .BC-BackAction {
  display: flex;
  padding: 0 18px;
}

.theme-setting-visual-editor .BC-BackAction .Polaris-Icon {
  margin: 0 !important;
}

.theme-setting-popover-menu {
  min-width: 198px;
}

.theme-setting-visual-editor .visual-editor-header__action .Polaris-ButtonGroup__Item {
  margin-left: 16px;
}

.theme-setting-visual-editor .btn-dots {
  border-radius: 4px;
  border: 1px solid #babfc3;
}

.theme-setting-visual-editor .btn-dots button {
  background-color: #fff !important;
  padding: 8px 9px;
}

.theme-setting-visual-editor .btn-dots:hover button {
  background-color: #f1f2f3 !important;
}

.theme-setting-visual-editor .visual-editor-body {
  width: 100%;
  display: flex;
  height: calc(100vh - 56px);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e1e3e5;
  overflow: auto;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview {
  width: calc(100% - 300px - 300px);
  left: 300px;
  transition: 0.4s all ease-in-out;
  position: relative;
  overflow: unset;
  overflow-x: hidden;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview.full {
  width: 100%;
  left: 0;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview.overflow-hidden {
  overflow: hidden;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .boost-sd__filter-block {
  width: calc(100%);
  transition: 0.4s all ease-in-out;
  position: relative;
  height: 100%;
  overflow: auto;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .btn-expand {
  width: 60px;
  height: 60px;
  background: #fafbfb;
  border-width: 0px 0px 1px 1px;
  border-style: solid;
  border-color: #e1e3e5;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);
  transition: 0.3s all ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  transform: translate(80px, 0);
  z-index: 516;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .btn-expand.show {
  transform: translate(0, 0);
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.overflow-hidden
  .btn-expand.show {
  box-shadow: none;
  border-bottom: none;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .loading {
  position: fixed;
  top: 0;
  left: 300px;
  z-index: 99;
  width: calc(100% - 600px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-preview.full .loading {
  width: calc(100% - 300px);
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .loading
  .Polaris-Spinner
  svg {
  fill: white;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-left-panel-container {
  display: flex;
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-left: 1px solid #e1e3e5;
  position: relative;
  transition: 0.3s all ease-in-out;
  position: fixed;
  top: 56px;
  left: 0;
  transform: translate(-360px, 0);
  z-index: 500;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-left-panel-container.opened {
  transform: translate(0, 0);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel-container {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border-left: 1px solid #e1e3e5;
  position: relative;
  transition: 0.3s all ease-in-out;
  position: fixed;
  top: 56px;
  right: 0;
  transform: translate(360px, 0);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel-container.opened {
  transform: translate(0, 0);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__scroll {
  overflow: auto;
  height: calc(100% - 108px);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__scroll.not-remove {
  height: calc(100% - 56px);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel {
  margin-top: -1rem;
  min-height: calc(100% - 60px);
  padding: 1rem;
  padding-top: 0;
  padding-bottom: 1px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel .default-text-style {
  font-weight: 400 !important;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel
  .Polaris-Label__Text--disabled {
  color: #8c9196;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel
  .visual-editor-right-panel__content.h-full {
  max-height: 100%;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .Polaris-FormLayout {
  margin-top: 0;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section.form-section--bordered {
  box-shadow: inset 0px 1px 0px #e4e5e7;
  margin: 0 -16px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px;
  cursor: pointer;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .section-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
  margin: 0 !important;
  display: flex;
  align-items: center;
  text-transform: uppercase;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .section-title.uppercase {
  text-transform: uppercase;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .section-title
  .Polaris-Icon {
  display: flex;
  align-items: center;
  max-width: max-content;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .section-title
  .Polaris-Icon__Svg {
  width: 14px;
  height: 14px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .caret {
  transition: 0.3s all;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .caret.closed {
  transform: rotate(180deg);
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .section-title-collapse__wrapper
  .caret.collapsed {
  transform: rotate(90deg);
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .ReactCollapse--collapse {
  padding: 0 16px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .ReactCollapse--collapse[aria-hidden='false'] {
  margin-bottom: 20px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__form .form-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-title
  .Polaris-Icon {
  margin: 0;
  width: 12px;
  height: 12px;
  position: relative;
  top: 2px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .title {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section__item
  .title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section__item
  .title.title--small {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  + .form-section__item {
  margin-top: 8px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-Connected__Item:first-child {
  align-self: center;
  width: calc(100% - 34px - 43px);
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-Connected__Item:last-child {
  margin-left: 0;
  width: 34px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item.form-section__item--slider
  .Polaris-TextField__Backdrop {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-Connected__Item
  .Polaris-TextField__Input {
  padding-top: 5px;
  padding-bottom: 5px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-Connected__Item--primary {
  width: 43px;
  min-width: 43px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .text-field-unit {
  border-radius: 0px 4px 4px 0px;
  background: #f1f2f3;
  border: 1px solid #babfc3;
  border-left: 0;
  box-shadow: inset 0px 2px 0px rgba(0, 0, 0, 0.05);
  padding: 7px 8px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .text-field-unit
  span {
  position: relative;
  top: -1px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb__Input {
  --pc-single-thumb-progress-lower: #008060;
  --p-focused: transparent;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {
  background: #008060;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb--disabled
  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {
  background: #f1f1f1 !important;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {
  background: #008060;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-RangeSlider-SingleThumb--disabled
  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {
  background: #f1f1f1 !important;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item.form-section__item--small-spacing {
  margin-top: 5px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item.form-section__item--medium-spacing {
  margin-top: 12px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item.form-section__item--standard-spacing {
  margin-top: 16px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .form-section__item
  .Polaris-TextField__Input {
  padding-top: 6px;
  padding-bottom: 6px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone {
  padding: 25px 47px;
  background: #f1f2f3;
  border-radius: 4px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .custom-dropzone-standard-v2
  .Polaris-DropZone__Container
  > div {
  padding: 24px 12px 16px !important;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .custom-dropzone-standard-v2.uploaded
  .Polaris-DropZone__Container
  > div {
  padding: 24px 12px 8px !important;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-Stack__Item
  .Polaris-Stack__Item {
  margin-top: 4px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-TextStyle--variationSubdued {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #8c9196;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--focused)::after {
  border-radius: 4px;
  border: 1px solid #babfc3;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-DropZone
  .Polaris-TextStyle--variationSubdued {
  color: #202223;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-ThemeSettings_Dropzone
  .Polaris-DropZone.Polaris-DropZone--isDisabled
  .Polaris-TextStyle--variationSubdued {
  color: #8c9196;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__form .form-link {
  color: #2c6ecb;
  align-items: center;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-link
  a:visited {
  color: #2c6ecb;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-link
  .Polaris-Icon {
  margin: 0;
  margin-left: 2px;
  display: inline-block;
  position: relative;
  top: 2.5px;
  width: 15px;
  height: 15px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-link
  .Polaris-Icon
  svg {
  fill: #2c6ecb;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-link.form-link--normal
  .Polaris-Icon
  svg {
  fill: #5c5f62;
}
.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-link.form-link--normal
  .Polaris-Icon {
  top: 1px;
  margin-left: 0;
  width: 14px;
  height: 14px;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__top {
  width: 142px;
  height: 145px;
  display: flex;
  flex-direction: column;
  gap: 14.44px;
  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/sample.svg');
  background-size: 100% 100%;
  background-color: #edeeef;
}

.form-link__product-image-area-tooltip
  .form-link__product-image-area-tooltip__top
  .form-link__product-image-area-tooltip__item {
  width: 100%;
  height: 38px;
  border-radius: 4px;
  border: 1.455px dashed #5c5f62;
  background: rgba(255, 255, 255, 0.7);
}

.form-link__product-image-area-tooltip
  .form-link__product-image-area-tooltip__top
  .form-link__product-image-area-tooltip__item.active {
  background: #2c6ecb;
  border-color: transparent;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body {
  margin-top: 8.73px;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .name {
  font-size: 10.182px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.102px;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .vendor {
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.4px;
  margin-top: 3px;
  color: #7d7d7d;
}

.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .price {
  font-family: Poppins;
  font-size: 11.636px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.582px;
  margin-top: 6px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__form .icon-app-rating {
  width: 32px;
  height: 32px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .icon-app-rating
  img {
  max-width: 100%;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix {
  position: relative;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  > div:first-child {
  z-index: 1;
  position: relative;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  .Polaris-TextField__Input {
  padding-right: 50px;
  min-height: 48px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  .select-borderless {
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 10;
  background-color: transparent;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  .select-borderless
  > div
  > div {
  width: max-content;
  border: none !important;
  box-shadow: none !important;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  .select-borderless
  .BC-Select__control {
  min-height: auto;
  width: 32px;
  height: 32px;
  cursor: pointer;
  border: none !important;
  box-shadow: none !important;
  background: #f1f2f3;
  border-radius: 4px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  .select-borderless
  .BC-Select__control
  .BC-Select__value-container {
  justify-content: center;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .input-wrapper-suffix
  .select-borderless
  .BC-Select__control
  .BC-Select__placeholder {
  font-size: 18px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .BC-Select__control--is-disabled {
  background: #fafbfb;
  border: 1px solid #c9cccf;
  opacity: 0.6;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .BC-Select__control--is-disabled
  .BC-Select__placeholder {
  color: #8c9196;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .BC-Select__control--is-disabled
  .BC-Select__indicator
  .Polaris-Icon__Svg {
  fill: #8c9196;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-right-panel__form
  .form-section
  .BC-Select__single-value
  .help-text {
  display: none;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview:has(.visual-editor-preview__overlay)
  .loading {
  display: none;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview:has(.visual-editor-preview__overlay)
  .boost-sd__filter-block {
  overflow: hidden;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay {
  width: 100%;
  transition: 0.4s all ease-in-out;
  background-color: rgba(34, 34, 34, 0.6);
  position: absolute;
  z-index: 50;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  padding-top: 60px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview.full
  .visual-editor-preview__overlay {
  width: 100%;
  /* overflow: unset; */
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-preview
  .visual-editor-preview__overlay
  .quick-view-popup {
  max-height: calc(100% - 60px - 60px);
  display: flex;
  position: absolute;
  left: 50%;
  overflow-x: hidden;
  overflow-y: auto;
  transform: translate(-50%, 0);
  background: #ffffff;
}

.quick-view-popup--collapse .close-popup-btn {
  position: absolute;
  top: 18.68px;
  right: 18.68px;
}

.quick-view-popup--collapse .product-gallery {
  display: flex;
}

.quick-view-popup--collapse .product-gallery.product-gallery--horizontal {
  flex-direction: row;
}

.quick-view-popup--collapse .product-gallery.product-gallery--vertical {
  flex-direction: column-reverse;
  justify-content: flex-end;
}

.quick-view-popup--collapse .product-gallery--horizontal .product-gallery__thumbnails-wrapper {
  width: 73.2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15.24px 0;
  gap: 11.45px;
}

.quick-view-popup--collapse .product-gallery .product-gallery__thumbnails {
  display: flex;
  gap: 12.2px;
}

.quick-view-popup--collapse .product-gallery--horizontal .product-gallery__thumbnails {
  flex-direction: column;
}

.quick-view-popup--collapse .product-gallery .product-gallery__single-thumbnail {
  width: 48.8px;
  height: 65.58px;
  border: 0.7625px solid #cecece;
  border-radius: 2.2875px;
  object-fit: cover;
  object-position: center;
}

.quick-view-popup--collapse .product-gallery .product-gallery__single-thumbnail--bordered {
  border: 1px solid #1d1d1d;
}

.quick-view-popup--collapse .product-gallery .product-gallery__pagination-wrapper {
  width: 18.3px;
  height: 18.3px;
  background-color: #e9e9e9;
  margin: 0;
  border-radius: 50%;
  display: none;
}

.quick-view-popup--collapse .product-gallery .product-gallery__pagination-wrapper.visible {
  display: inline-block;
}

.quick-view-popup--collapse .product-gallery .product-gallery__pagination-wrapper > span {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-gallery--vertical .product-gallery__pagination-wrapper .Polaris-Icon {
  transform: rotate(-90deg);
}

.quick-view-popup--collapse .product-gallery--vertical .product-gallery__thumbnails-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 11.45px;
  padding: 15.24px 15.24px;
}

.quick-view-popup--collapse
  .product-gallery--vertical:has(.visible)
  .product-gallery__thumbnails-wrapper {
  justify-content: center;
  padding: 15.24px 0px;
}

.quick-view-popup--collapse .product-gallery--vertical .product-gallery__thumbnails {
  flex-direction: row;
}

.quick-view-popup--collapse .product-gallery .product-gallery__single-photo {
  object-fit: cover;
  object-position: center;
}

.quick-view-popup--collapse .product-gallery--horizontal .product-gallery__single-photo {
  width: 292.8px;
  height: 388.88px;
}

.quick-view-popup--collapse .product-gallery--vertical .product-gallery__single-photo {
  width: 310px;
  height: 398.88px;
}

.quick-view-popup--collapse .product-information {
  width: 366px;
  padding: 24.4px 24.4px 0 24.4px;
  display: flex;
  flex-direction: column;
}

.quick-view-popup--collapse .product-information .product-information__name {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  color: #222222;
  margin-bottom: 6.1px;
}

.quick-view-popup--collapse .product-information .product-information__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #7a7a7a;
  margin-bottom: 24.4px;
}

.quick-view-popup--collapse .product-information .product-information__price {
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #222222;
  margin-bottom: 15.25px;
}

.quick-view-popup--collapse .product-information .product-information__options .product-option {
  margin-bottom: 15.25px;
}

.quick-view-popup--collapse
  .product-information
  .product-information__options
  .product-option__title {
  margin-bottom: 8px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.quick-view-popup--collapse
  .product-information
  .product-information__options
  .product-option__value {
  display: flex;
  gap: 6.1px;
  flex-wrap: wrap;
}

.quick-view-popup--collapse
  .product-information
  .product-information__options
  .product-option__outline-color {
  width: 38px;
  height: 38px;
  border: 0.8px solid #e8e9eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-view-popup--collapse
  .product-information
  .product-information__options
  .product-option__color {
  width: 31.67px;
  height: 31.67px;
  border-radius: 50%;
}

.quick-view-popup--collapse
  .product-information
  .product-information__options
  .product-option__text {
  min-width: 61px;
  max-width: 100px;
  min-height: 27.45px;
  padding: 6.1px 10px;
  border-radius: 30.5px;
  border: 0.7625px solid #e8e9eb;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #222222;
}

.quick-view-popup--collapse
  .product-information
  .product-information__options
  .product-option__text--selected {
  color: #ffffff;
  border: none;
  background-color: #222222;
}

.quick-view-popup--collapse .product-information .quantity-counter {
  margin-bottom: 24.4px;
}

.quick-view-popup--collapse .product-information .quantity-counter .quantity-counter__title {
  margin-bottom: 8px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.quick-view-popup--collapse .product-information .quantity-counter .quantity-counter__counter {
  width: 152.5px;
  height: 28.98px;
  background: #ffffff;
  border: 0.7625px solid #ebebeb;
  border-radius: 38.125px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.quick-view-popup--collapse .product-information .buttons {
  display: flex;
  gap: 12.2px;
  margin-top: auto;
}

.quick-view-popup--collapse .product-information .buttons__item {
  width: 152.5px;
  min-height: 34.3px;
  text-align: center;
  padding: 9.15px 15.25px;
  background: #ffffff;
  border: 0.7625px solid #4e4e4e;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quick-view-popup--collapse .product-information .buttons__item:hover {
  cursor: pointer;
}

.quick-view-popup--collapse .product-information .buttons__item.buttons__item--rounded {
  border-radius: 61px;
}

.quick-view-popup--collapse .product-information .hyperlink {
  margin-top: 37.35px;
  padding-bottom: 25.5px;
  display: flex;
  gap: 5.72px;
  justify-content: flex-start;
  align-items: center;
}

.quick-view-popup--collapse .product-information .hyperlink > span {
  margin: 0;
}

.quick-view-popup--collapse .product-information .hyperlink__url {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #0f0f0f;
}

.quick-view-popup--expand .close-popup-btn {
  position: absolute;
  top: 24.5px;
  right: 24.5px;
}

.quick-view-popup--expand .product-gallery {
  display: flex;
}

.quick-view-popup--expand .product-gallery.product-gallery--horizontal {
  flex-direction: row;
}

.quick-view-popup--expand .product-gallery.product-gallery--vertical {
  flex-direction: column-reverse;
  justify-content: flex-end;
}

.quick-view-popup--expand .product-gallery--horizontal .product-gallery__thumbnails-wrapper {
  width: 96px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  gap: 14px;
}

.quick-view-popup--expand .product-gallery .product-gallery__thumbnails {
  display: flex;
  gap: 16px;
}

.quick-view-popup--expand .product-gallery--horizontal .product-gallery__thumbnails {
  flex-direction: column;
}

.quick-view-popup--expand .product-gallery .product-gallery__single-thumbnail {
  width: 64px;
  height: 86px;
  border: 1px solid #cecece;
  border-radius: 3px;
  object-fit: cover;
  object-position: center;
}

.quick-view-popup--expand .product-gallery .product-gallery__single-thumbnail--bordered {
  border: 1px solid #1d1d1d;
}

.quick-view-popup--expand .product-gallery .product-gallery__pagination-wrapper {
  width: 20px;
  height: 20px;
  background-color: #e9e9e9;
  margin: 0;
  border-radius: 50%;
  display: none;
}

.quick-view-popup--expand .product-gallery .product-gallery__pagination-wrapper.visible {
  display: inline-block;
}

.quick-view-popup--expand .product-gallery .product-gallery__pagination-wrapper > span {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quick-view-popup--expand .product-gallery--vertical .product-gallery__thumbnails-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px 16px;
  gap: 14px;
}

.quick-view-popup--expand
  .product-gallery--vertical:has(.visible)
  .product-gallery__thumbnails-wrapper {
  justify-content: center;
  padding: 16px 0px;
}

.quick-view-popup--expand .product-gallery--vertical .product-gallery__thumbnails {
  flex-direction: row;
}

.quick-view-popup--expand .product-gallery .product-gallery__single-photo {
  width: 384px;
  height: 510px;
  margin-left: auto;
  object-fit: cover;
  object-position: center;
}

.quick-view-popup--expand .product-information {
  width: 480px;
  padding: 32px 32px 0 32px;
  display: flex;
  flex-direction: column;
}

.quick-view-popup--expand .product-information .product-information__name {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  color: #222222;
  margin-bottom: 8px;
}

.quick-view-popup--expand .product-information .product-information__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #7a7a7a;
  margin-bottom: 32px;
}

.quick-view-popup--expand .product-information .product-information__price {
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #222222;
  margin-bottom: 20px;
}

.quick-view-popup--expand .product-information .product-information__options {
}

.quick-view-popup--expand .product-information .product-information__options .product-option {
  margin-bottom: 20px;
}

.quick-view-popup--expand
  .product-information
  .product-information__options
  .product-option__title {
  margin-bottom: 8px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.quick-view-popup--expand
  .product-information
  .product-information__options
  .product-option__value {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.quick-view-popup--expand
  .product-information
  .product-information__options
  .product-option__outline-color {
  width: 38px;
  height: 38px;
  border: 0.8px solid #e8e9eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-view-popup--expand
  .product-information
  .product-information__options
  .product-option__color {
  width: 31.67px;
  height: 31.67px;
  border-radius: 50%;
}

.quick-view-popup--expand .product-information .product-information__options .product-option__text {
  min-width: 80px;
  max-width: 110px;
  min-height: 36px;
  padding: 8px 11px;
  border: 1px solid #e8e9eb;
  border-radius: 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #222222;
}

.quick-view-popup--expand
  .product-information
  .product-information__options
  .product-option__text--selected {
  color: #ffffff;
  border: none;
  background-color: #222222;
}

.quick-view-popup--expand .product-information .quantity-counter {
  margin-bottom: 32px;
}

.quick-view-popup--expand .product-information .quantity-counter .quantity-counter__title {
  margin-bottom: 8px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.quick-view-popup--expand .product-information .quantity-counter .quantity-counter__counter {
  width: 200px;
  height: 38px;
  border: 1px solid #ebebeb;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.quick-view-popup--expand .product-information .buttons {
  display: flex;
  gap: 16px;
  margin-top: auto;
  margin-bottom: 54px;
}

.quick-view-popup--expand .product-information .buttons__item {
  width: 200px;
  height: 44px;
  padding: 12px 20px;
  border: 1px solid #4e4e4e;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quick-view-popup--expand .product-information .buttons__item:hover {
  cursor: pointer;
}

.quick-view-popup--expand .product-information .buttons__item.buttons__item--rounded {
  border-radius: 80px;
}

.quick-view-popup--expand .product-information .hyperlink {
  padding-bottom: 34px;
  display: flex;
  gap: 7.5px;
  justify-content: flex-start;
  align-items: center;
}

.quick-view-popup--expand .product-information .hyperlink > span {
  margin: 0;
}

.quick-view-popup--expand .product-information .hyperlink__url {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #0f0f0f;
}

.quick-view-popup--mobile {
  width: 350px;
  max-height: 667px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px 24px 24px;
}

.quick-view-popup::-webkit-scrollbar {
  width: 8px;
}

.quick-view-popup::-webkit-scrollbar-track {
  background-color: #ffffff;
}

.quick-view-popup::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

.quick-view-popup--mobile .close-popup-btn {
  position: absolute;
  top: 20.5px;
  right: 20.5px;
}

.quick-view-popup--mobile .product-gallery {
  display: flex;
}

.quick-view-popup--mobile .product-gallery.product-gallery--vertical {
  flex-direction: column-reverse;
  justify-content: flex-end;
}

.quick-view-popup--mobile .product-gallery .product-gallery__thumbnails {
  display: flex;
  gap: 8px;
}

.quick-view-popup--mobile .product-gallery--horizontal .product-gallery__thumbnails {
  flex-direction: column;
}

.quick-view-popup--mobile .product-gallery .product-gallery__single-thumbnail {
  width: 64px;
  height: 86px;
  border: 1px solid #cecece;
  border-radius: 3px;
  object-fit: cover;
  object-position: center;
}

.quick-view-popup--mobile .product-gallery .product-gallery__single-thumbnail--bordered {
  border: 1px solid #1d1d1d;
}

.quick-view-popup--mobile .product-gallery .product-gallery__pagination-wrapper {
  width: 20px;
  height: 20px;
  background-color: #e9e9e9;
  margin: 0;
  border-radius: 50%;
  display: none;
}

.quick-view-popup--mobile .product-gallery .product-gallery__pagination-wrapper.visible {
  display: inline-block;
}

.quick-view-popup--mobile .product-gallery .product-gallery__pagination-wrapper > span {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quick-view-popup--mobile .product-gallery--vertical .product-gallery__thumbnails-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px 0px;
  gap: 7px;
}

.quick-view-popup--mobile .product-gallery--vertical .product-gallery__thumbnails {
  flex-direction: row;
}

.quick-view-popup--mobile .product-gallery .product-gallery__single-photo {
  width: 295px;
  height: 392px;
  margin: auto;
  object-fit: cover;
  object-position: center;
}

.quick-view-popup--mobile .product-information {
  width: 295px;
}

.quick-view-popup--mobile .product-information .product-information__name {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  color: #222222;
}

.quick-view-popup--mobile .product-information .product-information__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #7a7a7a;
  margin-top: 8px;
}

.quick-view-popup--mobile .product-information .product-information__price {
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #222222;
  margin-top: 24px;
}

.quick-view-popup--mobile .product-information .product-information__options .product-option {
  margin-top: 20px;
}

.quick-view-popup--mobile
  .product-information
  .product-information__options
  .product-option__value {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.quick-view-popup--mobile
  .product-information
  .product-information__options
  .product-option__title {
  margin-bottom: 8px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.quick-view-popup--mobile
  .product-information
  .product-information__options
  .product-option__outline-color {
  width: 38px;
  height: 38px;
  border: 0.8px solid #e8e9eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-view-popup--mobile
  .product-information
  .product-information__options
  .product-option__color {
  width: 31.67px;
  height: 31.67px;
  border-radius: 50%;
}

.quick-view-popup--mobile .product-information .product-information__options .product-option__text {
  min-width: 80px;
  max-width: 110px;
  min-height: 36px;
  padding: 8px 11px;
  border: 1px solid #e8e9eb;
  border-radius: 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #222222;
}

.quick-view-popup--mobile
  .product-information
  .product-information__options
  .product-option__text--selected {
  color: #ffffff;
  border: none;
  background-color: #222222;
}

.quick-view-popup--mobile .product-information .quantity-counter {
  margin-top: 20px;
}

.quick-view-popup--mobile .product-information .quantity-counter .quantity-counter__title {
  margin-bottom: 8px;
  color: #222222;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.quick-view-popup--mobile .product-information .quantity-counter .quantity-counter__counter {
  width: 200px;
  height: 38px;
  border: 1px solid #ebebeb;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.quick-view-popup--mobile .product-information .buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
}

.quick-view-popup--mobile .product-information .buttons__item {
  width: 295px;
  height: 44px;
  padding: 12px 20px;
  border: 1px solid #4e4e4e;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quick-view-popup--mobile .product-information .buttons__item:hover {
  cursor: pointer;
}

.quick-view-popup--mobile .product-information .buttons__item.buttons__item--rounded {
  border-radius: 80px;
}

.quick-view-popup--mobile .product-information .hyperlink {
  margin-top: 52px;
  display: flex;
  gap: 7.5px;
  justify-content: flex-start;
  align-items: center;
}

.quick-view-popup--mobile .product-information .hyperlink > span {
  margin: 0;
}

.quick-view-popup--mobile .product-information .hyperlink__url {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;
  color: #0f0f0f;
}

.BC-Select__option {
  border-radius: 4px;
  margin-top: 4px;
}

.BC-Select__option:first-child {
  margin-top: 0px !important;
}

.BC-Select__option:not(.BC-Select__option--is-selected) .help-text {
  color: #6d7175;
}

.BC-Select__option.BC-Select__option--is-selected .help-text {
  color: white;
}

.theme-setting-visual-editor .visual-editor-body .grid-radio-button__wrapper {
  background-color: #fafbfb;
  padding: 8px;
  border: 1px solid #c9cccf;
  border-radius: 4px;
}

.theme-setting-visual-editor .visual-editor-body .grid-radio-button {
  margin: auto;
  width: 140px;
  min-width: 140px;
  display: grid;
  grid-template-columns: 44px 44px 44px;
  gap: 4px;
}

.theme-setting-visual-editor .visual-editor-body .grid-radio-button .Polaris-Button {
  height: 44px;
}

.theme-setting-visual-editor .visual-editor-body .radio-button-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 8px;
  margin-top: 4px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-gap {
  column-gap: 0;
}

.theme-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper
  .radio-button-2
  .Polaris-Button {
  padding: 8px 16px;
}

.theme-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-gap
  .radio-button-2:first-child
  .Polaris-Button {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.theme-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--no-gap
  .radio-button-2:last-child
  .Polaris-Button {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.theme-setting-visual-editor
  .visual-editor-body
  .radio-button-wrapper.radio-button-wrapper--bordered
  .radio-button-2:first-child
  .Polaris-Button {
  border-right: var(--p-border-width-1) solid var(--p-border-neutral-subdued);
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings {
  position: relative;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .inner {
  overflow: auto;
  height: calc(100% - 127px);
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .theme-setting-menu-divider-section {
  padding: 12px 20px;
  background: #f1f2f3;
  border-top: 1px solid #e1e3e5;
  border-bottom: 1px solid #e1e3e5;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .theme-setting-menu-divider-section
  .divider-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
}

.theme-setting-visual-editor
  .visual-editor-body
  .visual-editor-settings
  .theme-setting-menu-divider-section
  .Polaris-Icon {
  width: 14px;
  height: 14px;
  margin-left: 4px;
}

.theme-setting-visual-editor .visual-editor-body .reset-wrapper {
  padding: 1rem;
  position: absolute;
  bottom: 56px;
  width: 100%;
  box-shadow: inset 0px 1px 0px #e4e5e7;
}

.theme-setting-visual-editor .visual-editor-body .reset-wrapper button {
  white-space: nowrap;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .menu-section {
  border-bottom: 1px solid #e1e3e5;
  padding: 8px 20px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .menu-section:last-child {
  box-shadow: unset;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .menu-section p {
  color: #6d7175;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-top: 2px;
  margin-bottom: 1px;
}

.widget-layout-settings > div:not(:first-child),
.widget-title-settings > div:not(:first-child) {
  padding-top: 16px;
}

.widget-layout-settings div ul li {
  padding-top: 12px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings.title-bold-normal {
  height: 56px;
  display: flex;
  align-items: center !important;
}

.theme-setting-visual-editor .visual-editor-header .select-theme-preview {
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.theme-setting-visual-editor .visual-editor-header .select-theme-preview > div:first-child {
  flex-grow: 1;
}

.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__Wrapper {
  border-bottom-color: transparent;
}

.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__Tab .Polaris-Tabs__Title::before {
  bottom: -9px;
  border-radius: 0;
  height: 2px;
}

.theme-setting-visual-editor
  .visual-editor-header
  .Polaris-Tabs__Tab--selected
  .Polaris-Tabs__Title::before {
  background: #44474a;
}

.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__Tab--selected .Polaris-Icon__Svg {
  fill: #44474a;
}

.theme-setting-visual-editor .visual-editor-header .theme-preview {
  width: 375px;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: -110px;
}

.theme-setting-visual-editor .visual-editor-header .theme-preview.shopify-integration {
  margin: 0;
  width: auto;
  margin-left: -202px;
}

.theme-setting-visual-editor .visual-editor-header .theme-preview .theme-preview-label {
  margin-right: 20px;
  margin-left: 20px;
}

.theme-setting-visual-editor .visual-editor-header .theme-preview .theme-preview-label span {
  margin-top: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
}

.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs {
  margin-left: 20px;
}
.theme-setting-visual-editor
  .visual-editor-header
  .theme-preview.shopify-integration
  .Polaris-Tabs {
  margin-left: 0;
}

.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__DisclosureActivator {
  display: none;
}

.theme-setting-visual-editor .visual-editor-right-panel-container .title-section {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 0;
  padding: 18px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.theme-setting-visual-editor .visual-editor-right-panel-container .title-section .btn-collapse {
  cursor: pointer;
}

.theme-setting-visual-editor .visual-editor-right-panel-container .title-section .Polaris-Icon {
  margin: 0;
}

.theme-setting-visual-editor .visual-editor-right-panel .description-panel {
  color: #6d7175;
  margin-top: 1rem;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__remove {
  position: absolute;
  bottom: 56px;
  left: 0;
  display: flex;
  padding: 16px;
  box-shadow: inset 0px 1px 0px #e4e5e7;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
  color: #6d7175;
  background: #fff;
  z-index: 999;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__remove .Polaris-Icon {
  margin: 0;
  margin-right: 4px;
}

.visual-editor-right-panel .Polaris-Tooltip-TooltipOverlay {
  max-width: 254px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding: 18px 16px;
  border-bottom: 1px solid #e1e3e5;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item {
  border-bottom: 1px solid #e1e3e5;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item.borderless {
  box-shadow: none;
  border-bottom: none;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item:last-child {
  box-shadow: none;
  border-bottom: none;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.not-collapsible {
  padding-left: 41px;
}

.theme-setting-visual-editor .visual-editor-settings .ReactCollapse--collapse {
  padding-left: 16px;
  padding-right: 16px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .ReactCollapse--collapse {
  padding: 0;
  margin-left: 40px;
  margin-right: 8px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .ReactCollapse--collapse {
  margin-left: 40px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .ReactCollapse--collapse
  .ReactCollapse--collapse {
  margin-left: 26px;
  margin-right: 0;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item .title-wrapper {
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: 0.3s all ease-in-out;
  cursor: pointer;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .title-inner {
  display: flex;
  align-items: center;
  padding: 8px 0;
  width: 100%;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .title-wrapper {
  padding-right: 0;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .title-wrapper
  > .title-inner {
  padding-right: 16px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item.has-submenu
  .ReactCollapse--collapse
  .title-wrapper {
  padding-left: 4px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active {
  background: #f1f8f5;
  color: #008060;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active
  .Polaris-Icon__Svg {
  fill: #008060;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active
  .Polaris-Icon__Svg
  path {
  fill: #008060;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active.disabled
  .Polaris-Icon__Svg
  path {
  fill: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  > .btn-view-by-page {
  margin-left: auto;
  margin-right: 28px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.not-collapsible {
  padding: 0;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.not-collapsible
  .title-inner {
  padding-left: 41px;
  padding-right: 16px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active {
  background: #f1f8f5;
  color: #008060;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active
  .Polaris-Icon__Svg {
  fill: #008060;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled {
  color: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  .Polaris-Icon__Svg {
  fill: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  ~ .ReactCollapse--collapse
  .theme-setting-menu-children:not(.btn-add) {
  color: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  ~ .ReactCollapse--collapse
  .theme-setting-menu-children:not(.btn-add)
  .Polaris-Icon__Svg
  path {
  fill: var(--p-icon);
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  ~ .ReactCollapse--collapse
  .theme-setting-menu-children.disabled:not(.btn-add)
  .Polaris-Icon__Svg
  path {
  fill: #8c9196 !important;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children,
#draggable .theme-setting-menu-children {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  transition: 0.3s background ease-in-out;
  border-radius: 4px;
  cursor: pointer;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.area {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  justify-content: flex-start;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-droppable {
  min-height: 4px;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.active,
#draggable .theme-setting-menu-children.active {
  background: #f1f8f5;
  color: #008060;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active
  .Polaris-Icon__Svg
  rect,
#draggable .theme-setting-menu-children.active .Polaris-Icon__Svg rect {
  fill: #008060;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children .Polaris-Icon {
  margin: 0;
  margin-right: 8px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action
  .Polaris-Icon {
  margin: 0;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.disabled,
#draggable .theme-setting-menu-children.disabled {
  color: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.disabled .Polaris-Icon svg {
  fill: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled
  .btn-drag
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.disabled .btn-drag .Polaris-Icon svg {
  fill: var(--p-icon) !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.active .Polaris-Icon svg {
  fill: #008060 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active
  .btn-drag
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.active .btn-drag .Polaris-Icon svg {
  fill: #008060 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.active.disabled
  .btn-view
  .Polaris-Icon
  svg,
#draggable .theme-setting-menu-children.active.disabled .btn-view .Polaris-Icon svg {
  fill: #8c9196 !important;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.disabled
  .btn-view-by-page,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.disabled
  .btn-view,
#draggable .theme-setting-menu-children.disabled .btn-view {
  opacity: 1;
  visibility: visible;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.btn-add {
  color: #2c6ecb;
  justify-content: flex-start;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.btn-add
  .Polaris-Icon {
  display: flex;
  align-items: center;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.btn-add
  .Polaris-Icon
  svg {
  fill: #2c6ecb;
  width: 16px;
  height: 16px;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.btn-add.disabled {
  pointer-events: none !important;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children__action,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item .btn-view-by-page,
.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children__action .btn-view,
.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children__action .btn-drag,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children__action
  .btn-remove {
  visibility: hidden;
  opacity: 0;
  transition: 0.2s all;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .theme-setting-menu-children__action.show
  .btn-view,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .theme-setting-menu-children__action.show
  .btn-drag,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children
  .theme-setting-menu-children__action.show
  .btn-remove,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-view,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-drag,
#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-remove {
  opacity: 1;
  visibility: visible;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper:hover
  .btn-view-by-page,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover
  .theme-setting-menu-children__action
  .btn-view,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover
  .theme-setting-menu-children__action
  .btn-drag,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children:hover
  .theme-setting-menu-children__action
  .btn-remove,
#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-view,
#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-drag,
#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-remove {
  opacity: 1;
  visibility: visible;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item .title-wrapper:hover,
.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children:hover,
#draggable .theme-setting-menu-children:hover {
  background: #f6f6f7;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper.active:hover,
.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.active:hover,
#draggable .theme-setting-menu-children.active:hover {
  background: #f1f8f5;
}

.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children > span,
#draggable .theme-setting-menu-children > span {
  display: block;
  max-width: 125px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret {
  padding: 8px 0;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret {
  margin-right: 5px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret
  .Polaris-Icon {
  transition: 0.2s all ease-in-out;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .caret.closed
  .Polaris-Icon {
  transform: rotate(-90deg);
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .menu-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .menu-icon {
  margin-right: 8px;
}

.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-item
  .title-wrapper
  .menu-icon
  svg,
.theme-setting-visual-editor
  .visual-editor-settings
  .theme-setting-menu-children.area
  .menu-icon
  svg {
  width: 18px;
  height: 18px;
}

.theme-setting-menu-children__menu-add {
  padding: 8px 0;
  min-width: 220px;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Title {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #6d7175;
  padding: 8px 16px;
  text-transform: uppercase;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Actions {
  padding: 0;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Item {
  padding: 8px 16px;
  border-radius: 0;
  width: 219px;
}

.theme-setting-menu-children__menu-add .Polaris-ActionList__Item:hover {
  color: #008060;
  background: #f1f8f5;
}

.draggable-zone.dragging {
  border-radius: 8px;
  border: 1px dashed var(--interactive);
}

.draggable-zone.draggable-zone--margin-left {
  margin-left: 18px;
}

.draggable-zone.dragging.draggable-zone--margin-left {
  margin-right: 8px;
}

/* Layout modal */

.BC-theme-setting-layout-modal {
  display: flex;
  width: 100%;
  height: 100%;
}

.BC-theme-setting-layout-modal-icon-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.BC-theme-setting-layout-modal-icon-title svg {
  width: 21.6px;
  height: 21.6px;
}

.BC-theme-setting-layout-modal .Polaris-Tabs__Wrapper {
  padding: 0 4px;
}

.BC-theme-setting-layout-modal .form-section__item .Polaris-Choice__Descriptions {
  padding: 0;
}

.BC-theme-setting-layout-modal .form-section__item .Polaris-Choice__Descriptions .sub-layout-item {
  margin-top: 14px;
  padding: 12px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  border: none;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .sub-layout-item.active {
  outline: 2px solid #8c9196;
}

.BC-theme-setting-layout-modal .form-section__item .sub-layout-item .sub-layout-item__image {
  padding: 16px 37px;
  background: #edeeef;
  position: relative;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .Polaris-ButtonGroup__Item:first-child {
  flex: 1 1 100%;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .Polaris-Button {
  background-color: #fff;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .Polaris-Button
  svg {
  fill: #31373d;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .Polaris-Button:hover {
  background-color: var(--p-action-secondary-hovered);
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .Polaris-Button:active {
  background-color: var(--p-action-secondary-pressed);
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .btn-view
  .Polaris-Button {
  width: 40px;
  height: 40px;
  padding: 0;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .btn-view
  .Polaris-Button__Text {
  display: flex;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action--top {
  position: absolute;
  top: 0;
  right: 0;
  bottom: unset;
  left: unset;
  width: max-content;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action--bottom {
  position: absolute;
  right: 0;
  bottom: 0;
  left: unset;
  width: max-content;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action--small
  .btn-action
  .Polaris-Button {
  width: 40px;
  height: 40px;
  padding: 0;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action--small
  .btn-action--circle
  .Polaris-Button {
  border-radius: 50%;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action--small
  .btn-action
  .Polaris-Button__Text {
  display: flex;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action--small
  .Polaris-Icon {
  width: 1rem;
  height: 1rem;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__image
  .sub-layout-item__action
  .Polaris-Button__Icon {
  width: 1rem;
  height: 1rem;
}

.BC-theme-setting-layout-modal .form-section__item .sub-layout-item .sub-layout-item__info {
  margin-top: 12px;
  text-align: left;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__info
  .product-name {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #121212;
  margin-bottom: 4px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__info
  .product-vendor {
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #7d7d7d;
  margin-bottom: 9px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__info
  .product-price {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #121212;
  letter-spacing: 0.05em;
}

.BC-theme-setting-layout-modal .form-section__item .sub-layout-item > .sub-layout-item__action {
  margin-top: 12px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__action
  .Polaris-Button {
  border: 1px solid #414141;
  border-radius: 0;
  padding: 10px 23px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .sub-layout-item
  .sub-layout-item__action
  .Polaris-Button__Text {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #202223;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item {
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: none;
  padding: 12px;
  margin-top: 12px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-1,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-2 {
  height: 224px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item.active {
  outline: 2px solid #8c9196;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item
  .Polaris-Grid,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item
  .Polaris-Grid-Cell,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item
  .Polaris-Grid-Cell
  .collection-header-item__content {
  height: 100%;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-1
  .collection-header-item__content {
  background: #f1f2f3;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-left: 30px;
  border-radius: 4px 0px 0px 4px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item
  .title {
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  margin-bottom: 4px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item
  .description {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-1
  .title,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-1
  .description,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-3
  .title,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-3
  .description,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-4
  .description {
  color: #000000;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-1
  .collection-header-item__bg {
  height: 100%;
  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-half-sample.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #e0e3e7;
  border-radius: 0px 4px 4px 0px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-2
  .title,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-2
  .description,
.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-4
  .title {
  color: #ffffff;
  z-index: 2;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-2
  .collection-header-item__content {
  background-color: #e0e3e7;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  border-radius: 4px;
  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-sample.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-2
  .overlay {
  background: rgba(34, 34, 34, 0.6);
  border-radius: 4px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-3 {
  height: 300px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-4 {
  height: 268px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-3
  .collection-header-item__bg {
  background-color: #e0e3e7;
  border-radius: 4px;
  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-sample.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 200px;
  position: relative;
  margin-bottom: 8px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-4
  .collection-header-item__bg {
  background-color: #e0e3e7;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  border-radius: 4px;
  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-sample.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 200px;
  position: relative;
  z-index: 1;
  margin-bottom: 16px;
}

.BC-theme-setting-layout-modal
  .form-section__item
  .Polaris-Choice__Descriptions
  .collection-header-item-4
  .overlay {
  background: rgba(34, 34, 34, 0.6);
  border-radius: 4px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.BC-theme-setting-layout-modal .form-section__item .default-text-style {
  font-weight: 400 !important;
}

.BC-theme-setting-layout-modal .form-section__item .Polaris-RadioButton__Backdrop::before {
  width: 10px;
  height: 10px;
}

.BC-theme-setting-layout-modal .form-section__item .filter-layout-item {
  margin-top: 10px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
}

.BC-theme-setting-layout-modal .form-section__item .filter-layout-item.active {
  outline: 2px solid #8c9196;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu {
  display: flex;
  width: 184px;
  padding: 8px 8px 0;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-right: 1px solid #e1e3e5;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item {
  display: flex;
  padding: 10px 8px;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  border-radius: 4px;
  cursor: pointer;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item:hover {
  background: #f1f2f3;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item.active {
  background: #f2f7fe;
  position: relative;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: -8px;
  border-radius: 0px 4px 4px 0px;
  background: #2c6ecb;
  width: 3px;
  height: 100%;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__content {
  flex: 1;
  height: 100%;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__content > div {
  height: 100%;
}

.BC-theme-setting-layout-modal .BC-theme-setting-page-templates__loading {
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__content .Polaris-Tabs__Panel {
  height: calc(100% - 53px);
}

.BC-theme-setting-layout-modal .Polaris-Tabs__Panel .Polaris-Card__Section {
  padding: 1.25rem 1.25rem;
  height: 100%;
  overflow: auto;
}

.btn-group-polaris .Polaris-ButtonGroup__Item {
  margin-left: 10px;
}

/* Preview theme setting overwrite css */
.boost-sd__filter-option-content-inner,
.boost-sd__sorting-button,
/* .boost-sd__pagination, */
.boost-sd__search-form-input,
.boost-sd__search-form .boost-sd__button,
.boost-sd__filter-tree-toggle-button {
  pointer-events: none;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar {
  display: flex;
  width: 52px;
  height: 100%;
  padding: 6px 20px;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  border-right: 1px solid #e1e3e5;
  background: #fff;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item {
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item:hover,
.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item.active {
  background: #f1f2f3;
}

.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-PositionedOverlay {
  z-index: 520;
}

.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen {
  max-width: 1164px;
  height: calc(100vh - 3.75rem);
}

.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor
  ~ #PolarisPortalsContainer
  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen
  .Polaris-Modal__Body
  > .Polaris-Modal-Section {
  height: 100%;
  padding: 0;
}

.BC-theme-setting-page-templates {
  padding: 20px;
}

.BC-theme-setting-page-templates .BC-theme-setting-page-templates__title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
}

.BC-theme-setting-page-templates .BC-theme-setting-page-templates__desc {
  color: #6d7175;
  margin-bottom: 20px;
}

.BC-theme-setting-page-templates__search .BC-theme-setting-page-templates__search-input {
  display: flex;
  padding: 8px 12px;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #c9cccf;
  background: #fff;
}

.BC-theme-setting-page-templates__search .BC-theme-setting-page-templates__search-input.focused {
  border-color: #1a1a1a;
  border-width: 0.0625rem;
  background-color: #f7f7f7;
  outline: 0.125rem solid #005bd3;
  outline-offset: 0.0625rem;
}

.BC-theme-setting-page-templates__search
  .BC-theme-setting-page-templates__search-input
  .Polaris-TextField__Input {
  padding: 0;
  padding-left: 8px;
  height: 20px;
  min-height: unset;
}

.BC-theme-setting-page-templates__content {
  margin-top: 12px;
  height: calc(100% - 142px);
}

.BC-theme-setting-page-templates__content .BC-theme-setting-page-templates__content-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.BC-theme-setting-page-templates__content
  .BC-theme-setting-page-templates__content-header
  .BC-Select__control {
  width: 140px;
}

.BC-theme-setting-page-templates__content .BC-theme-setting-page-templates__content-body {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  column-gap: 20px;
  row-gap: 24px;
  margin-top: 20px;
  overflow: auto;
  height: calc(100% - 56px);
  position: relative;
}

.BC-theme-setting-page-templates__content .BC-theme-setting-page-templates__content-body.chrome {
  margin-right: -4px;
}

.BC-theme-setting-page-templates__content
  .BC-theme-setting-page-templates__content-body.firefox-mac {
  margin-right: -16px;
}

.BC-theme-setting-page-templates__content
  .BC-theme-setting-page-templates__content-body::-webkit-scrollbar {
  width: 4px;
}

.BC-theme-setting-page-templates__content
  .BC-theme-setting-page-templates__content-body::-webkit-scrollbar-thumb {
  background: #cccccc;
  border-radius: 4px;
}

.BC-theme-setting-page-templates__no-result {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.BC-theme-setting-page-templates__no-result .Polaris-Icon,
.BC-theme-setting-page-templates__no-result .Polaris-Icon__Svg {
  width: 60px;
  height: 60px;
}

.BC-theme-setting-page-templates__no-result .title {
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.BC-theme-setting-page-templates__content .BC-template-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 220px;
}

.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__thumbnail {
  border-radius: 8px;
  /* box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.20); */
  height: 200px;
  width: 100%;
  position: relative;
}

.BC-theme-setting-page-templates__content .BC-template-item.active .BC-template-item__thumbnail {
  border-radius: 8px;
  border: 2px solid #2c6ecb;
  position: relative;
}

.BC-theme-setting-page-templates__content
  .BC-template-item.active
  .BC-template-item__thumbnail
  .BC-template-item__selected-tag {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 2px 8px;
  background: #2c6ecb;
  position: absolute;
  top: 0;
  right: -2px;
  font-size: 12px;
  color: #fff;
}

.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__thumbnail img {
  height: 100%;
}

.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__thumbnail .overlay {
  opacity: 0;
  visibility: hidden;
  transition: 0.15s all ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  gap: 10px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.BC-theme-setting-page-templates__content
  .BC-template-item
  .BC-template-item__thumbnail:hover
  .overlay {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
  opacity: 1;
  visibility: visible;
}

.BC-theme-setting-page-templates__content
  .BC-template-item
  .BC-template-item__thumbnail
  .overlay
  .Polaris-Button {
  width: 107px;
  padding: 7px 12px;
}

.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__name {
  font-weight: 600;
  text-transform: capitalize;
}

.BC-preview-template {
  width: 100%;
  height: 100%;
}

.BC-preview-template .BC-preview-template__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  border-radius: 8px 8px 0px 0px;
  background: #fff;
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
  position: relative;
  height: 56px;
}

.BC-preview-template .BC-preview-template__header-mid .Polaris-Tabs__Tab {
  width: 56px;
  height: 56px;
  padding: 0;
}

.BC-preview-template
  .BC-preview-template__header-mid
  .Polaris-Tabs__Tab--selected
  .Polaris-Tabs__Title::before {
  background: #44474a;
  bottom: -7.5px;
  border-radius: 0;
  height: 2px;
}

.BC-preview-template .BC-preview-template__header-right .Polaris-Button {
  width: 69px;
  padding: 7px 12px;
}

.BC-preview-template .BC-preview-template__header-left .btn-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  text-transform: capitalize;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
}

.BC-preview-template .BC-preview-template__header-mid {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.BC-preview-template__body {
  width: 100%;
  background: #f3f5f6;
  text-align: center;
  height: calc(100% - 56px);
  overflow: auto;
}

.BC-preview-template__body img {
  max-width: 100%;
}

/* New theme setting */
`, "",{"version":3,"sources":["webpack://./src/styles/theme-settings.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,2EAA2E;EAC3E,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,OAAO;EACP,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,oBAAoB;AACtB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;;;;;EAME,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;EAME,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;EAME,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;;;EAME,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,kCAAkC;AACpC;;AAEA;;;;;;;;EAQE,iCAAiC;AACnC;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;AACA;;;;;EAKE,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;EAME,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;;EAKE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;EAGE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;EAGE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;EAKE,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;;;;EAKE,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;EAUE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;EAWE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2EAA2E;EAC3E,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;;EAME,mDAAmD;AACrD;;AAEA;;;;;;EAME,mDAAmD;AACrD;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;;;;;;EAOE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;EAIE,2EAA2E;EAC3E,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;EAgBE,YAAY;AACd;;AAEA;;;;;EAKE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;EACZ,6FAA6F;EAC7F,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;EAeE,cAAc;EACd,UAAU;AACZ;;AAEA;;;;;EAKE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,wFAAwF;EACxF,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;EAKE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,wFAAwF;EACxF,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;EAKE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,wFAAwF;EACxF,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;EAKE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mFAAmF;AACrF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;;;;;;EAME,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;;;EAKE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,iFAAiF;EACjF,8CAA8C;EAC9C,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB","sourcesContent":["/* New theme setting */\n.theme-setting-visual-editor .Polaris-FullscreenBar {\n  z-index: 517;\n}\n\n.theme-setting-visual-editor .Polaris-Frame__Content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.theme-setting-visual-editor .visual-editor-header {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 0 1rem;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-name {\n  display: flex;\n  align-items: center;\n  max-width: 335px;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-name p {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-name p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 85%;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-name .Polaris-Badge {\n  background: #a4e8f2;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  margin-left: 8px;\n}\n\n.theme-setting-visual-editor .Polaris-FullscreenBar__BackAction {\n  display: none;\n}\n\n.theme-setting-visual-editor .BC-BackAction {\n  display: flex;\n  padding: 0 18px;\n}\n\n.theme-setting-visual-editor .BC-BackAction .Polaris-Icon {\n  margin: 0 !important;\n}\n\n.theme-setting-popover-menu {\n  min-width: 198px;\n}\n\n.theme-setting-visual-editor .visual-editor-header__action .Polaris-ButtonGroup__Item {\n  margin-left: 16px;\n}\n\n.theme-setting-visual-editor .btn-dots {\n  border-radius: 4px;\n  border: 1px solid #babfc3;\n}\n\n.theme-setting-visual-editor .btn-dots button {\n  background-color: #fff !important;\n  padding: 8px 9px;\n}\n\n.theme-setting-visual-editor .btn-dots:hover button {\n  background-color: #f1f2f3 !important;\n}\n\n.theme-setting-visual-editor .visual-editor-body {\n  width: 100%;\n  display: flex;\n  height: calc(100vh - 56px);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings {\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-right: 1px solid #e1e3e5;\n  overflow: auto;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview {\n  width: calc(100% - 300px - 300px);\n  left: 300px;\n  transition: 0.4s all ease-in-out;\n  position: relative;\n  overflow: unset;\n  overflow-x: hidden;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview.full {\n  width: 100%;\n  left: 0;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview.overflow-hidden {\n  overflow: hidden;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .boost-sd__filter-block {\n  width: calc(100%);\n  transition: 0.4s all ease-in-out;\n  position: relative;\n  height: 100%;\n  overflow: auto;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .btn-expand {\n  width: 60px;\n  height: 60px;\n  background: #fafbfb;\n  border-width: 0px 0px 1px 1px;\n  border-style: solid;\n  border-color: #e1e3e5;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);\n  transition: 0.3s all ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n  transform: translate(80px, 0);\n  z-index: 516;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .btn-expand.show {\n  transform: translate(0, 0);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.overflow-hidden\n  .btn-expand.show {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview .loading {\n  position: fixed;\n  top: 0;\n  left: 300px;\n  z-index: 99;\n  width: calc(100% - 600px);\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-preview.full .loading {\n  width: calc(100% - 300px);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .loading\n  .Polaris-Spinner\n  svg {\n  fill: white;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-left-panel-container {\n  display: flex;\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-left: 1px solid #e1e3e5;\n  position: relative;\n  transition: 0.3s all ease-in-out;\n  position: fixed;\n  top: 56px;\n  left: 0;\n  transform: translate(-360px, 0);\n  z-index: 500;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-left-panel-container.opened {\n  transform: translate(0, 0);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel-container {\n  width: 300px;\n  height: 100%;\n  background: #ffffff;\n  border-left: 1px solid #e1e3e5;\n  position: relative;\n  transition: 0.3s all ease-in-out;\n  position: fixed;\n  top: 56px;\n  right: 0;\n  transform: translate(360px, 0);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel-container.opened {\n  transform: translate(0, 0);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__scroll {\n  overflow: auto;\n  height: calc(100% - 108px);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__scroll.not-remove {\n  height: calc(100% - 56px);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel {\n  margin-top: -1rem;\n  min-height: calc(100% - 60px);\n  padding: 1rem;\n  padding-top: 0;\n  padding-bottom: 1px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel .default-text-style {\n  font-weight: 400 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel\n  .Polaris-Label__Text--disabled {\n  color: #8c9196;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel\n  .visual-editor-right-panel__content.h-full {\n  max-height: 100%;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .Polaris-FormLayout {\n  margin-top: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section.form-section--bordered {\n  box-shadow: inset 0px 1px 0px #e4e5e7;\n  margin: 0 -16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 16px;\n  cursor: pointer;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n  margin: 0 !important;\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title.uppercase {\n  text-transform: uppercase;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title\n  .Polaris-Icon {\n  display: flex;\n  align-items: center;\n  max-width: max-content;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .section-title\n  .Polaris-Icon__Svg {\n  width: 14px;\n  height: 14px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .caret {\n  transition: 0.3s all;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .caret.closed {\n  transform: rotate(180deg);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .section-title-collapse__wrapper\n  .caret.collapsed {\n  transform: rotate(90deg);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .ReactCollapse--collapse {\n  padding: 0 16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .ReactCollapse--collapse[aria-hidden='false'] {\n  margin-bottom: 20px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__form .form-title {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-title\n  .Polaris-Icon {\n  margin: 0;\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 2px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section__item\n  .title {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 4px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section__item\n  .title.title--small {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  + .form-section__item {\n  margin-top: 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item:first-child {\n  align-self: center;\n  width: calc(100% - 34px - 43px);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item:last-child {\n  margin-left: 0;\n  width: 34px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item.form-section__item--slider\n  .Polaris-TextField__Backdrop {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item\n  .Polaris-TextField__Input {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-Connected__Item--primary {\n  width: 43px;\n  min-width: 43px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .text-field-unit {\n  border-radius: 0px 4px 4px 0px;\n  background: #f1f2f3;\n  border: 1px solid #babfc3;\n  border-left: 0;\n  box-shadow: inset 0px 2px 0px rgba(0, 0, 0, 0.05);\n  padding: 7px 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .text-field-unit\n  span {\n  position: relative;\n  top: -1px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb__Input {\n  --pc-single-thumb-progress-lower: #008060;\n  --p-focused: transparent;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {\n  background: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb--disabled\n  .Polaris-RangeSlider-SingleThumb__Input::-webkit-slider-thumb {\n  background: #f1f1f1 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {\n  background: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-RangeSlider-SingleThumb--disabled\n  .Polaris-RangeSlider-SingleThumb__Input::-moz-range-thumb {\n  background: #f1f1f1 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item.form-section__item--small-spacing {\n  margin-top: 5px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item.form-section__item--medium-spacing {\n  margin-top: 12px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item.form-section__item--standard-spacing {\n  margin-top: 16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .form-section__item\n  .Polaris-TextField__Input {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone {\n  padding: 25px 47px;\n  background: #f1f2f3;\n  border-radius: 4px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .custom-dropzone-standard-v2\n  .Polaris-DropZone__Container\n  > div {\n  padding: 24px 12px 16px !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .custom-dropzone-standard-v2.uploaded\n  .Polaris-DropZone__Container\n  > div {\n  padding: 24px 12px 8px !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-Stack__Item\n  .Polaris-Stack__Item {\n  margin-top: 4px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-TextStyle--variationSubdued {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8c9196;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--focused)::after {\n  border-radius: 4px;\n  border: 1px solid #babfc3;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-DropZone\n  .Polaris-TextStyle--variationSubdued {\n  color: #202223;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-ThemeSettings_Dropzone\n  .Polaris-DropZone.Polaris-DropZone--isDisabled\n  .Polaris-TextStyle--variationSubdued {\n  color: #8c9196;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__form .form-link {\n  color: #2c6ecb;\n  align-items: center;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-link\n  a:visited {\n  color: #2c6ecb;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-link\n  .Polaris-Icon {\n  margin: 0;\n  margin-left: 2px;\n  display: inline-block;\n  position: relative;\n  top: 2.5px;\n  width: 15px;\n  height: 15px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-link\n  .Polaris-Icon\n  svg {\n  fill: #2c6ecb;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-link.form-link--normal\n  .Polaris-Icon\n  svg {\n  fill: #5c5f62;\n}\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-link.form-link--normal\n  .Polaris-Icon {\n  top: 1px;\n  margin-left: 0;\n  width: 14px;\n  height: 14px;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__top {\n  width: 142px;\n  height: 145px;\n  display: flex;\n  flex-direction: column;\n  gap: 14.44px;\n  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/sample.svg');\n  background-size: 100% 100%;\n  background-color: #edeeef;\n}\n\n.form-link__product-image-area-tooltip\n  .form-link__product-image-area-tooltip__top\n  .form-link__product-image-area-tooltip__item {\n  width: 100%;\n  height: 38px;\n  border-radius: 4px;\n  border: 1.455px dashed #5c5f62;\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.form-link__product-image-area-tooltip\n  .form-link__product-image-area-tooltip__top\n  .form-link__product-image-area-tooltip__item.active {\n  background: #2c6ecb;\n  border-color: transparent;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body {\n  margin-top: 8.73px;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .name {\n  font-size: 10.182px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.102px;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .vendor {\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.4px;\n  margin-top: 3px;\n  color: #7d7d7d;\n}\n\n.form-link__product-image-area-tooltip .form-link__product-image-area-tooltip__body .price {\n  font-family: Poppins;\n  font-size: 11.636px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.582px;\n  margin-top: 6px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__form .icon-app-rating {\n  width: 32px;\n  height: 32px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .icon-app-rating\n  img {\n  max-width: 100%;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix {\n  position: relative;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  > div:first-child {\n  z-index: 1;\n  position: relative;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  .Polaris-TextField__Input {\n  padding-right: 50px;\n  min-height: 48px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  .select-borderless {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  z-index: 10;\n  background-color: transparent;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  .select-borderless\n  > div\n  > div {\n  width: max-content;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  .select-borderless\n  .BC-Select__control {\n  min-height: auto;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n  border: none !important;\n  box-shadow: none !important;\n  background: #f1f2f3;\n  border-radius: 4px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  .select-borderless\n  .BC-Select__control\n  .BC-Select__value-container {\n  justify-content: center;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .input-wrapper-suffix\n  .select-borderless\n  .BC-Select__control\n  .BC-Select__placeholder {\n  font-size: 18px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .BC-Select__control--is-disabled {\n  background: #fafbfb;\n  border: 1px solid #c9cccf;\n  opacity: 0.6;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .BC-Select__control--is-disabled\n  .BC-Select__placeholder {\n  color: #8c9196;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .BC-Select__control--is-disabled\n  .BC-Select__indicator\n  .Polaris-Icon__Svg {\n  fill: #8c9196;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-right-panel__form\n  .form-section\n  .BC-Select__single-value\n  .help-text {\n  display: none;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview:has(.visual-editor-preview__overlay)\n  .loading {\n  display: none;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview:has(.visual-editor-preview__overlay)\n  .boost-sd__filter-block {\n  overflow: hidden;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay {\n  width: 100%;\n  transition: 0.4s all ease-in-out;\n  background-color: rgba(34, 34, 34, 0.6);\n  position: absolute;\n  z-index: 50;\n  top: 0;\n  left: 0;\n  height: 100%;\n  overflow: hidden;\n  padding-top: 60px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview.full\n  .visual-editor-preview__overlay {\n  width: 100%;\n  /* overflow: unset; */\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-preview\n  .visual-editor-preview__overlay\n  .quick-view-popup {\n  max-height: calc(100% - 60px - 60px);\n  display: flex;\n  position: absolute;\n  left: 50%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  transform: translate(-50%, 0);\n  background: #ffffff;\n}\n\n.quick-view-popup--collapse .close-popup-btn {\n  position: absolute;\n  top: 18.68px;\n  right: 18.68px;\n}\n\n.quick-view-popup--collapse .product-gallery {\n  display: flex;\n}\n\n.quick-view-popup--collapse .product-gallery.product-gallery--horizontal {\n  flex-direction: row;\n}\n\n.quick-view-popup--collapse .product-gallery.product-gallery--vertical {\n  flex-direction: column-reverse;\n  justify-content: flex-end;\n}\n\n.quick-view-popup--collapse .product-gallery--horizontal .product-gallery__thumbnails-wrapper {\n  width: 73.2px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 15.24px 0;\n  gap: 11.45px;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__thumbnails {\n  display: flex;\n  gap: 12.2px;\n}\n\n.quick-view-popup--collapse .product-gallery--horizontal .product-gallery__thumbnails {\n  flex-direction: column;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__single-thumbnail {\n  width: 48.8px;\n  height: 65.58px;\n  border: 0.7625px solid #cecece;\n  border-radius: 2.2875px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__single-thumbnail--bordered {\n  border: 1px solid #1d1d1d;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__pagination-wrapper {\n  width: 18.3px;\n  height: 18.3px;\n  background-color: #e9e9e9;\n  margin: 0;\n  border-radius: 50%;\n  display: none;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__pagination-wrapper.visible {\n  display: inline-block;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__pagination-wrapper > span {\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-gallery--vertical .product-gallery__pagination-wrapper .Polaris-Icon {\n  transform: rotate(-90deg);\n}\n\n.quick-view-popup--collapse .product-gallery--vertical .product-gallery__thumbnails-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 11.45px;\n  padding: 15.24px 15.24px;\n}\n\n.quick-view-popup--collapse\n  .product-gallery--vertical:has(.visible)\n  .product-gallery__thumbnails-wrapper {\n  justify-content: center;\n  padding: 15.24px 0px;\n}\n\n.quick-view-popup--collapse .product-gallery--vertical .product-gallery__thumbnails {\n  flex-direction: row;\n}\n\n.quick-view-popup--collapse .product-gallery .product-gallery__single-photo {\n  object-fit: cover;\n  object-position: center;\n}\n\n.quick-view-popup--collapse .product-gallery--horizontal .product-gallery__single-photo {\n  width: 292.8px;\n  height: 388.88px;\n}\n\n.quick-view-popup--collapse .product-gallery--vertical .product-gallery__single-photo {\n  width: 310px;\n  height: 398.88px;\n}\n\n.quick-view-popup--collapse .product-information {\n  width: 366px;\n  padding: 24.4px 24.4px 0 24.4px;\n  display: flex;\n  flex-direction: column;\n}\n\n.quick-view-popup--collapse .product-information .product-information__name {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 36px;\n  color: #222222;\n  margin-bottom: 6.1px;\n}\n\n.quick-view-popup--collapse .product-information .product-information__description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #7a7a7a;\n  margin-bottom: 24.4px;\n}\n\n.quick-view-popup--collapse .product-information .product-information__price {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  color: #222222;\n  margin-bottom: 15.25px;\n}\n\n.quick-view-popup--collapse .product-information .product-information__options .product-option {\n  margin-bottom: 15.25px;\n}\n\n.quick-view-popup--collapse\n  .product-information\n  .product-information__options\n  .product-option__title {\n  margin-bottom: 8px;\n  color: #222222;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quick-view-popup--collapse\n  .product-information\n  .product-information__options\n  .product-option__value {\n  display: flex;\n  gap: 6.1px;\n  flex-wrap: wrap;\n}\n\n.quick-view-popup--collapse\n  .product-information\n  .product-information__options\n  .product-option__outline-color {\n  width: 38px;\n  height: 38px;\n  border: 0.8px solid #e8e9eb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quick-view-popup--collapse\n  .product-information\n  .product-information__options\n  .product-option__color {\n  width: 31.67px;\n  height: 31.67px;\n  border-radius: 50%;\n}\n\n.quick-view-popup--collapse\n  .product-information\n  .product-information__options\n  .product-option__text {\n  min-width: 61px;\n  max-width: 100px;\n  min-height: 27.45px;\n  padding: 6.1px 10px;\n  border-radius: 30.5px;\n  border: 0.7625px solid #e8e9eb;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #222222;\n}\n\n.quick-view-popup--collapse\n  .product-information\n  .product-information__options\n  .product-option__text--selected {\n  color: #ffffff;\n  border: none;\n  background-color: #222222;\n}\n\n.quick-view-popup--collapse .product-information .quantity-counter {\n  margin-bottom: 24.4px;\n}\n\n.quick-view-popup--collapse .product-information .quantity-counter .quantity-counter__title {\n  margin-bottom: 8px;\n  color: #222222;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quick-view-popup--collapse .product-information .quantity-counter .quantity-counter__counter {\n  width: 152.5px;\n  height: 28.98px;\n  background: #ffffff;\n  border: 0.7625px solid #ebebeb;\n  border-radius: 38.125px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.quick-view-popup--collapse .product-information .buttons {\n  display: flex;\n  gap: 12.2px;\n  margin-top: auto;\n}\n\n.quick-view-popup--collapse .product-information .buttons__item {\n  width: 152.5px;\n  min-height: 34.3px;\n  text-align: center;\n  padding: 9.15px 15.25px;\n  background: #ffffff;\n  border: 0.7625px solid #4e4e4e;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quick-view-popup--collapse .product-information .buttons__item:hover {\n  cursor: pointer;\n}\n\n.quick-view-popup--collapse .product-information .buttons__item.buttons__item--rounded {\n  border-radius: 61px;\n}\n\n.quick-view-popup--collapse .product-information .hyperlink {\n  margin-top: 37.35px;\n  padding-bottom: 25.5px;\n  display: flex;\n  gap: 5.72px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.quick-view-popup--collapse .product-information .hyperlink > span {\n  margin: 0;\n}\n\n.quick-view-popup--collapse .product-information .hyperlink__url {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-decoration-line: underline;\n  color: #0f0f0f;\n}\n\n.quick-view-popup--expand .close-popup-btn {\n  position: absolute;\n  top: 24.5px;\n  right: 24.5px;\n}\n\n.quick-view-popup--expand .product-gallery {\n  display: flex;\n}\n\n.quick-view-popup--expand .product-gallery.product-gallery--horizontal {\n  flex-direction: row;\n}\n\n.quick-view-popup--expand .product-gallery.product-gallery--vertical {\n  flex-direction: column-reverse;\n  justify-content: flex-end;\n}\n\n.quick-view-popup--expand .product-gallery--horizontal .product-gallery__thumbnails-wrapper {\n  width: 96px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 0;\n  gap: 14px;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__thumbnails {\n  display: flex;\n  gap: 16px;\n}\n\n.quick-view-popup--expand .product-gallery--horizontal .product-gallery__thumbnails {\n  flex-direction: column;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__single-thumbnail {\n  width: 64px;\n  height: 86px;\n  border: 1px solid #cecece;\n  border-radius: 3px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__single-thumbnail--bordered {\n  border: 1px solid #1d1d1d;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__pagination-wrapper {\n  width: 20px;\n  height: 20px;\n  background-color: #e9e9e9;\n  margin: 0;\n  border-radius: 50%;\n  display: none;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__pagination-wrapper.visible {\n  display: inline-block;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__pagination-wrapper > span {\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.quick-view-popup--expand .product-gallery--vertical .product-gallery__thumbnails-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 16px 16px;\n  gap: 14px;\n}\n\n.quick-view-popup--expand\n  .product-gallery--vertical:has(.visible)\n  .product-gallery__thumbnails-wrapper {\n  justify-content: center;\n  padding: 16px 0px;\n}\n\n.quick-view-popup--expand .product-gallery--vertical .product-gallery__thumbnails {\n  flex-direction: row;\n}\n\n.quick-view-popup--expand .product-gallery .product-gallery__single-photo {\n  width: 384px;\n  height: 510px;\n  margin-left: auto;\n  object-fit: cover;\n  object-position: center;\n}\n\n.quick-view-popup--expand .product-information {\n  width: 480px;\n  padding: 32px 32px 0 32px;\n  display: flex;\n  flex-direction: column;\n}\n\n.quick-view-popup--expand .product-information .product-information__name {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 36px;\n  color: #222222;\n  margin-bottom: 8px;\n}\n\n.quick-view-popup--expand .product-information .product-information__description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #7a7a7a;\n  margin-bottom: 32px;\n}\n\n.quick-view-popup--expand .product-information .product-information__price {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  color: #222222;\n  margin-bottom: 20px;\n}\n\n.quick-view-popup--expand .product-information .product-information__options {\n}\n\n.quick-view-popup--expand .product-information .product-information__options .product-option {\n  margin-bottom: 20px;\n}\n\n.quick-view-popup--expand\n  .product-information\n  .product-information__options\n  .product-option__title {\n  margin-bottom: 8px;\n  color: #222222;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quick-view-popup--expand\n  .product-information\n  .product-information__options\n  .product-option__value {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.quick-view-popup--expand\n  .product-information\n  .product-information__options\n  .product-option__outline-color {\n  width: 38px;\n  height: 38px;\n  border: 0.8px solid #e8e9eb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quick-view-popup--expand\n  .product-information\n  .product-information__options\n  .product-option__color {\n  width: 31.67px;\n  height: 31.67px;\n  border-radius: 50%;\n}\n\n.quick-view-popup--expand .product-information .product-information__options .product-option__text {\n  min-width: 80px;\n  max-width: 110px;\n  min-height: 36px;\n  padding: 8px 11px;\n  border: 1px solid #e8e9eb;\n  border-radius: 40px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #222222;\n}\n\n.quick-view-popup--expand\n  .product-information\n  .product-information__options\n  .product-option__text--selected {\n  color: #ffffff;\n  border: none;\n  background-color: #222222;\n}\n\n.quick-view-popup--expand .product-information .quantity-counter {\n  margin-bottom: 32px;\n}\n\n.quick-view-popup--expand .product-information .quantity-counter .quantity-counter__title {\n  margin-bottom: 8px;\n  color: #222222;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quick-view-popup--expand .product-information .quantity-counter .quantity-counter__counter {\n  width: 200px;\n  height: 38px;\n  border: 1px solid #ebebeb;\n  border-radius: 50px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.quick-view-popup--expand .product-information .buttons {\n  display: flex;\n  gap: 16px;\n  margin-top: auto;\n  margin-bottom: 54px;\n}\n\n.quick-view-popup--expand .product-information .buttons__item {\n  width: 200px;\n  height: 44px;\n  padding: 12px 20px;\n  border: 1px solid #4e4e4e;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quick-view-popup--expand .product-information .buttons__item:hover {\n  cursor: pointer;\n}\n\n.quick-view-popup--expand .product-information .buttons__item.buttons__item--rounded {\n  border-radius: 80px;\n}\n\n.quick-view-popup--expand .product-information .hyperlink {\n  padding-bottom: 34px;\n  display: flex;\n  gap: 7.5px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.quick-view-popup--expand .product-information .hyperlink > span {\n  margin: 0;\n}\n\n.quick-view-popup--expand .product-information .hyperlink__url {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-decoration-line: underline;\n  color: #0f0f0f;\n}\n\n.quick-view-popup--mobile {\n  width: 350px;\n  max-height: 667px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 24px 24px 24px;\n}\n\n.quick-view-popup::-webkit-scrollbar {\n  width: 8px;\n}\n\n.quick-view-popup::-webkit-scrollbar-track {\n  background-color: #ffffff;\n}\n\n.quick-view-popup::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n.quick-view-popup--mobile .close-popup-btn {\n  position: absolute;\n  top: 20.5px;\n  right: 20.5px;\n}\n\n.quick-view-popup--mobile .product-gallery {\n  display: flex;\n}\n\n.quick-view-popup--mobile .product-gallery.product-gallery--vertical {\n  flex-direction: column-reverse;\n  justify-content: flex-end;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__thumbnails {\n  display: flex;\n  gap: 8px;\n}\n\n.quick-view-popup--mobile .product-gallery--horizontal .product-gallery__thumbnails {\n  flex-direction: column;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__single-thumbnail {\n  width: 64px;\n  height: 86px;\n  border: 1px solid #cecece;\n  border-radius: 3px;\n  object-fit: cover;\n  object-position: center;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__single-thumbnail--bordered {\n  border: 1px solid #1d1d1d;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__pagination-wrapper {\n  width: 20px;\n  height: 20px;\n  background-color: #e9e9e9;\n  margin: 0;\n  border-radius: 50%;\n  display: none;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__pagination-wrapper.visible {\n  display: inline-block;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__pagination-wrapper > span {\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.quick-view-popup--mobile .product-gallery--vertical .product-gallery__thumbnails-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 16px 0px;\n  gap: 7px;\n}\n\n.quick-view-popup--mobile .product-gallery--vertical .product-gallery__thumbnails {\n  flex-direction: row;\n}\n\n.quick-view-popup--mobile .product-gallery .product-gallery__single-photo {\n  width: 295px;\n  height: 392px;\n  margin: auto;\n  object-fit: cover;\n  object-position: center;\n}\n\n.quick-view-popup--mobile .product-information {\n  width: 295px;\n}\n\n.quick-view-popup--mobile .product-information .product-information__name {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 36px;\n  color: #222222;\n}\n\n.quick-view-popup--mobile .product-information .product-information__description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #7a7a7a;\n  margin-top: 8px;\n}\n\n.quick-view-popup--mobile .product-information .product-information__price {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  color: #222222;\n  margin-top: 24px;\n}\n\n.quick-view-popup--mobile .product-information .product-information__options .product-option {\n  margin-top: 20px;\n}\n\n.quick-view-popup--mobile\n  .product-information\n  .product-information__options\n  .product-option__value {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.quick-view-popup--mobile\n  .product-information\n  .product-information__options\n  .product-option__title {\n  margin-bottom: 8px;\n  color: #222222;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quick-view-popup--mobile\n  .product-information\n  .product-information__options\n  .product-option__outline-color {\n  width: 38px;\n  height: 38px;\n  border: 0.8px solid #e8e9eb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quick-view-popup--mobile\n  .product-information\n  .product-information__options\n  .product-option__color {\n  width: 31.67px;\n  height: 31.67px;\n  border-radius: 50%;\n}\n\n.quick-view-popup--mobile .product-information .product-information__options .product-option__text {\n  min-width: 80px;\n  max-width: 110px;\n  min-height: 36px;\n  padding: 8px 11px;\n  border: 1px solid #e8e9eb;\n  border-radius: 40px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #222222;\n}\n\n.quick-view-popup--mobile\n  .product-information\n  .product-information__options\n  .product-option__text--selected {\n  color: #ffffff;\n  border: none;\n  background-color: #222222;\n}\n\n.quick-view-popup--mobile .product-information .quantity-counter {\n  margin-top: 20px;\n}\n\n.quick-view-popup--mobile .product-information .quantity-counter .quantity-counter__title {\n  margin-bottom: 8px;\n  color: #222222;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quick-view-popup--mobile .product-information .quantity-counter .quantity-counter__counter {\n  width: 200px;\n  height: 38px;\n  border: 1px solid #ebebeb;\n  border-radius: 50px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.quick-view-popup--mobile .product-information .buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 32px;\n}\n\n.quick-view-popup--mobile .product-information .buttons__item {\n  width: 295px;\n  height: 44px;\n  padding: 12px 20px;\n  border: 1px solid #4e4e4e;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #222222;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quick-view-popup--mobile .product-information .buttons__item:hover {\n  cursor: pointer;\n}\n\n.quick-view-popup--mobile .product-information .buttons__item.buttons__item--rounded {\n  border-radius: 80px;\n}\n\n.quick-view-popup--mobile .product-information .hyperlink {\n  margin-top: 52px;\n  display: flex;\n  gap: 7.5px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.quick-view-popup--mobile .product-information .hyperlink > span {\n  margin: 0;\n}\n\n.quick-view-popup--mobile .product-information .hyperlink__url {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-decoration-line: underline;\n  color: #0f0f0f;\n}\n\n.BC-Select__option {\n  border-radius: 4px;\n  margin-top: 4px;\n}\n\n.BC-Select__option:first-child {\n  margin-top: 0px !important;\n}\n\n.BC-Select__option:not(.BC-Select__option--is-selected) .help-text {\n  color: #6d7175;\n}\n\n.BC-Select__option.BC-Select__option--is-selected .help-text {\n  color: white;\n}\n\n.theme-setting-visual-editor .visual-editor-body .grid-radio-button__wrapper {\n  background-color: #fafbfb;\n  padding: 8px;\n  border: 1px solid #c9cccf;\n  border-radius: 4px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .grid-radio-button {\n  margin: auto;\n  width: 140px;\n  min-width: 140px;\n  display: grid;\n  grid-template-columns: 44px 44px 44px;\n  gap: 4px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .grid-radio-button .Polaris-Button {\n  height: 44px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .radio-button-wrapper {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  column-gap: 8px;\n  margin-top: 4px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-gap {\n  column-gap: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper\n  .radio-button-2\n  .Polaris-Button {\n  padding: 8px 16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-gap\n  .radio-button-2:first-child\n  .Polaris-Button {\n  border-right: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--no-gap\n  .radio-button-2:last-child\n  .Polaris-Button {\n  border-left: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .radio-button-wrapper.radio-button-wrapper--bordered\n  .radio-button-2:first-child\n  .Polaris-Button {\n  border-right: var(--p-border-width-1) solid var(--p-border-neutral-subdued);\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings {\n  position: relative;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .inner {\n  overflow: auto;\n  height: calc(100% - 127px);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .theme-setting-menu-divider-section {\n  padding: 12px 20px;\n  background: #f1f2f3;\n  border-top: 1px solid #e1e3e5;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .theme-setting-menu-divider-section\n  .divider-title {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-body\n  .visual-editor-settings\n  .theme-setting-menu-divider-section\n  .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .reset-wrapper {\n  padding: 1rem;\n  position: absolute;\n  bottom: 56px;\n  width: 100%;\n  box-shadow: inset 0px 1px 0px #e4e5e7;\n}\n\n.theme-setting-visual-editor .visual-editor-body .reset-wrapper button {\n  white-space: nowrap;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .menu-section {\n  border-bottom: 1px solid #e1e3e5;\n  padding: 8px 20px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .menu-section:last-child {\n  box-shadow: unset;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .menu-section p {\n  color: #6d7175;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 2px;\n  margin-bottom: 1px;\n}\n\n.widget-layout-settings > div:not(:first-child),\n.widget-title-settings > div:not(:first-child) {\n  padding-top: 16px;\n}\n\n.widget-layout-settings div ul li {\n  padding-top: 12px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings.title-bold-normal {\n  height: 56px;\n  display: flex;\n  align-items: center !important;\n}\n\n.theme-setting-visual-editor .visual-editor-header .select-theme-preview {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.theme-setting-visual-editor .visual-editor-header .select-theme-preview > div:first-child {\n  flex-grow: 1;\n}\n\n.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__Wrapper {\n  border-bottom-color: transparent;\n}\n\n.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__Tab .Polaris-Tabs__Title::before {\n  bottom: -9px;\n  border-radius: 0;\n  height: 2px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-header\n  .Polaris-Tabs__Tab--selected\n  .Polaris-Tabs__Title::before {\n  background: #44474a;\n}\n\n.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__Tab--selected .Polaris-Icon__Svg {\n  fill: #44474a;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-preview {\n  width: 375px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-left: -110px;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-preview.shopify-integration {\n  margin: 0;\n  width: auto;\n  margin-left: -202px;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-preview .theme-preview-label {\n  margin-right: 20px;\n  margin-left: 20px;\n}\n\n.theme-setting-visual-editor .visual-editor-header .theme-preview .theme-preview-label span {\n  margin-top: 10px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs {\n  margin-left: 20px;\n}\n.theme-setting-visual-editor\n  .visual-editor-header\n  .theme-preview.shopify-integration\n  .Polaris-Tabs {\n  margin-left: 0;\n}\n\n.theme-setting-visual-editor .visual-editor-header .Polaris-Tabs__DisclosureActivator {\n  display: none;\n}\n\n.theme-setting-visual-editor .visual-editor-right-panel-container .title-section {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 0;\n  padding: 18px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.theme-setting-visual-editor .visual-editor-right-panel-container .title-section .btn-collapse {\n  cursor: pointer;\n}\n\n.theme-setting-visual-editor .visual-editor-right-panel-container .title-section .Polaris-Icon {\n  margin: 0;\n}\n\n.theme-setting-visual-editor .visual-editor-right-panel .description-panel {\n  color: #6d7175;\n  margin-top: 1rem;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__remove {\n  position: absolute;\n  bottom: 56px;\n  left: 0;\n  display: flex;\n  padding: 16px;\n  box-shadow: inset 0px 1px 0px #e4e5e7;\n  width: 100%;\n  cursor: pointer;\n  font-weight: 600;\n  color: #6d7175;\n  background: #fff;\n  z-index: 999;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-right-panel__remove .Polaris-Icon {\n  margin: 0;\n  margin-right: 4px;\n}\n\n.visual-editor-right-panel .Polaris-Tooltip-TooltipOverlay {\n  max-width: 254px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-settings .title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 18px 16px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item.borderless {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item:last-child {\n  box-shadow: none;\n  border-bottom: none;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.not-collapsible {\n  padding-left: 41px;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .ReactCollapse--collapse {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .ReactCollapse--collapse {\n  padding: 0;\n  margin-left: 40px;\n  margin-right: 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .ReactCollapse--collapse {\n  margin-left: 40px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .ReactCollapse--collapse\n  .ReactCollapse--collapse {\n  margin-left: 26px;\n  margin-right: 0;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item .title-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  transition: 0.3s all ease-in-out;\n  cursor: pointer;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .title-inner {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  width: 100%;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .title-wrapper {\n  padding-right: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .title-wrapper\n  > .title-inner {\n  padding-right: 16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item.has-submenu\n  .ReactCollapse--collapse\n  .title-wrapper {\n  padding-left: 4px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active {\n  background: #f1f8f5;\n  color: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active\n  .Polaris-Icon__Svg {\n  fill: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active\n  .Polaris-Icon__Svg\n  path {\n  fill: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active.disabled\n  .Polaris-Icon__Svg\n  path {\n  fill: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  > .btn-view-by-page {\n  margin-left: auto;\n  margin-right: 28px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.not-collapsible {\n  padding: 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.not-collapsible\n  .title-inner {\n  padding-left: 41px;\n  padding-right: 16px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active {\n  background: #f1f8f5;\n  color: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active\n  .Polaris-Icon__Svg {\n  fill: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled {\n  color: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  .Polaris-Icon__Svg {\n  fill: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  ~ .ReactCollapse--collapse\n  .theme-setting-menu-children:not(.btn-add) {\n  color: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  ~ .ReactCollapse--collapse\n  .theme-setting-menu-children:not(.btn-add)\n  .Polaris-Icon__Svg\n  path {\n  fill: var(--p-icon);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  ~ .ReactCollapse--collapse\n  .theme-setting-menu-children.disabled:not(.btn-add)\n  .Polaris-Icon__Svg\n  path {\n  fill: #8c9196 !important;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children,\n#draggable .theme-setting-menu-children {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n  transition: 0.3s background ease-in-out;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.area {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  justify-content: flex-start;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-droppable {\n  min-height: 4px;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.active,\n#draggable .theme-setting-menu-children.active {\n  background: #f1f8f5;\n  color: #008060;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active\n  .Polaris-Icon__Svg\n  rect,\n#draggable .theme-setting-menu-children.active .Polaris-Icon__Svg rect {\n  fill: #008060;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children .Polaris-Icon {\n  margin: 0;\n  margin-right: 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action\n  .Polaris-Icon {\n  margin: 0;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.disabled,\n#draggable .theme-setting-menu-children.disabled {\n  color: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.disabled .Polaris-Icon svg {\n  fill: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled\n  .btn-drag\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.disabled .btn-drag .Polaris-Icon svg {\n  fill: var(--p-icon) !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.active .Polaris-Icon svg {\n  fill: #008060 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active\n  .btn-drag\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.active .btn-drag .Polaris-Icon svg {\n  fill: #008060 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.active.disabled\n  .btn-view\n  .Polaris-Icon\n  svg,\n#draggable .theme-setting-menu-children.active.disabled .btn-view .Polaris-Icon svg {\n  fill: #8c9196 !important;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.disabled\n  .btn-view-by-page,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.disabled\n  .btn-view,\n#draggable .theme-setting-menu-children.disabled .btn-view {\n  opacity: 1;\n  visibility: visible;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.btn-add {\n  color: #2c6ecb;\n  justify-content: flex-start;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.btn-add\n  .Polaris-Icon {\n  display: flex;\n  align-items: center;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.btn-add\n  .Polaris-Icon\n  svg {\n  fill: #2c6ecb;\n  width: 16px;\n  height: 16px;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.btn-add.disabled {\n  pointer-events: none !important;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children__action,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item .btn-view-by-page,\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children__action .btn-view,\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children__action .btn-drag,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children__action\n  .btn-remove {\n  visibility: hidden;\n  opacity: 0;\n  transition: 0.2s all;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .theme-setting-menu-children__action.show\n  .btn-view,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .theme-setting-menu-children__action.show\n  .btn-drag,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children\n  .theme-setting-menu-children__action.show\n  .btn-remove,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-view,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-drag,\n#draggable .theme-setting-menu-children .theme-setting-menu-children__action.show .btn-remove {\n  opacity: 1;\n  visibility: visible;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper:hover\n  .btn-view-by-page,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover\n  .theme-setting-menu-children__action\n  .btn-view,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover\n  .theme-setting-menu-children__action\n  .btn-drag,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children:hover\n  .theme-setting-menu-children__action\n  .btn-remove,\n#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-view,\n#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-drag,\n#draggable .theme-setting-menu-children:hover .theme-setting-menu-children__action .btn-remove {\n  opacity: 1;\n  visibility: visible;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-item .title-wrapper:hover,\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children:hover,\n#draggable .theme-setting-menu-children:hover {\n  background: #f6f6f7;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper.active:hover,\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children.active:hover,\n#draggable .theme-setting-menu-children.active:hover {\n  background: #f1f8f5;\n}\n\n.theme-setting-visual-editor .visual-editor-settings .theme-setting-menu-children > span,\n#draggable .theme-setting-menu-children > span {\n  display: block;\n  max-width: 125px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret {\n  padding: 8px 0;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret {\n  margin-right: 5px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret\n  .Polaris-Icon {\n  transition: 0.2s all ease-in-out;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .caret.closed\n  .Polaris-Icon {\n  transform: rotate(-90deg);\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .menu-title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .menu-icon {\n  margin-right: 8px;\n}\n\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-item\n  .title-wrapper\n  .menu-icon\n  svg,\n.theme-setting-visual-editor\n  .visual-editor-settings\n  .theme-setting-menu-children.area\n  .menu-icon\n  svg {\n  width: 18px;\n  height: 18px;\n}\n\n.theme-setting-menu-children__menu-add {\n  padding: 8px 0;\n  min-width: 220px;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: #6d7175;\n  padding: 8px 16px;\n  text-transform: uppercase;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Actions {\n  padding: 0;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Item {\n  padding: 8px 16px;\n  border-radius: 0;\n  width: 219px;\n}\n\n.theme-setting-menu-children__menu-add .Polaris-ActionList__Item:hover {\n  color: #008060;\n  background: #f1f8f5;\n}\n\n.draggable-zone.dragging {\n  border-radius: 8px;\n  border: 1px dashed var(--interactive);\n}\n\n.draggable-zone.draggable-zone--margin-left {\n  margin-left: 18px;\n}\n\n.draggable-zone.dragging.draggable-zone--margin-left {\n  margin-right: 8px;\n}\n\n/* Layout modal */\n\n.BC-theme-setting-layout-modal {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.BC-theme-setting-layout-modal-icon-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.BC-theme-setting-layout-modal-icon-title svg {\n  width: 21.6px;\n  height: 21.6px;\n}\n\n.BC-theme-setting-layout-modal .Polaris-Tabs__Wrapper {\n  padding: 0 4px;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .Polaris-Choice__Descriptions {\n  padding: 0;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .Polaris-Choice__Descriptions .sub-layout-item {\n  margin-top: 14px;\n  padding: 12px;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  text-align: center;\n  border: none;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .sub-layout-item.active {\n  outline: 2px solid #8c9196;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .sub-layout-item .sub-layout-item__image {\n  padding: 16px 37px;\n  background: #edeeef;\n  position: relative;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .Polaris-ButtonGroup__Item:first-child {\n  flex: 1 1 100%;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .Polaris-Button {\n  background-color: #fff;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .Polaris-Button\n  svg {\n  fill: #31373d;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .Polaris-Button:hover {\n  background-color: var(--p-action-secondary-hovered);\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .Polaris-Button:active {\n  background-color: var(--p-action-secondary-pressed);\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .btn-view\n  .Polaris-Button {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .btn-view\n  .Polaris-Button__Text {\n  display: flex;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action--top {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: unset;\n  left: unset;\n  width: max-content;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action--bottom {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: unset;\n  width: max-content;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action--small\n  .btn-action\n  .Polaris-Button {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action--small\n  .btn-action--circle\n  .Polaris-Button {\n  border-radius: 50%;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action--small\n  .btn-action\n  .Polaris-Button__Text {\n  display: flex;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action--small\n  .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__image\n  .sub-layout-item__action\n  .Polaris-Button__Icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .sub-layout-item .sub-layout-item__info {\n  margin-top: 12px;\n  text-align: left;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__info\n  .product-name {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  color: #121212;\n  margin-bottom: 4px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__info\n  .product-vendor {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 16px;\n  color: #7d7d7d;\n  margin-bottom: 9px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__info\n  .product-price {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #121212;\n  letter-spacing: 0.05em;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .sub-layout-item > .sub-layout-item__action {\n  margin-top: 12px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__action\n  .Polaris-Button {\n  border: 1px solid #414141;\n  border-radius: 0;\n  padding: 10px 23px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .sub-layout-item\n  .sub-layout-item__action\n  .Polaris-Button__Text {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #202223;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item {\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  border: none;\n  padding: 12px;\n  margin-top: 12px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-1,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-2 {\n  height: 224px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item.active {\n  outline: 2px solid #8c9196;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item\n  .Polaris-Grid,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item\n  .Polaris-Grid-Cell,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item\n  .Polaris-Grid-Cell\n  .collection-header-item__content {\n  height: 100%;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-1\n  .collection-header-item__content {\n  background: #f1f2f3;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-left: 30px;\n  border-radius: 4px 0px 0px 4px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item\n  .title {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 36px;\n  margin-bottom: 4px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item\n  .description {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-1\n  .title,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-1\n  .description,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-3\n  .title,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-3\n  .description,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-4\n  .description {\n  color: #000000;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-1\n  .collection-header-item__bg {\n  height: 100%;\n  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-half-sample.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  background-color: #e0e3e7;\n  border-radius: 0px 4px 4px 0px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-2\n  .title,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-2\n  .description,\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-4\n  .title {\n  color: #ffffff;\n  z-index: 2;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-2\n  .collection-header-item__content {\n  background-color: #e0e3e7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  border-radius: 4px;\n  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-sample.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-2\n  .overlay {\n  background: rgba(34, 34, 34, 0.6);\n  border-radius: 4px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-3 {\n  height: 300px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-4 {\n  height: 268px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-3\n  .collection-header-item__bg {\n  background-color: #e0e3e7;\n  border-radius: 4px;\n  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-sample.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  height: 200px;\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-4\n  .collection-header-item__bg {\n  background-color: #e0e3e7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  border-radius: 4px;\n  background-image: url('https://cdn.boostcommerce.io/assets/theme-setting/bg-sample.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  height: 200px;\n  position: relative;\n  z-index: 1;\n  margin-bottom: 16px;\n}\n\n.BC-theme-setting-layout-modal\n  .form-section__item\n  .Polaris-Choice__Descriptions\n  .collection-header-item-4\n  .overlay {\n  background: rgba(34, 34, 34, 0.6);\n  border-radius: 4px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .default-text-style {\n  font-weight: 400 !important;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .Polaris-RadioButton__Backdrop::before {\n  width: 10px;\n  height: 10px;\n}\n\n.BC-theme-setting-layout-modal .form-section__item .filter-layout-item {\n  margin-top: 10px;\n  padding: 12px;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.2);\n}\n\n.BC-theme-setting-layout-modal .form-section__item .filter-layout-item.active {\n  outline: 2px solid #8c9196;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu {\n  display: flex;\n  width: 184px;\n  padding: 8px 8px 0;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  border-right: 1px solid #e1e3e5;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item {\n  display: flex;\n  padding: 10px 8px;\n  align-items: center;\n  align-self: stretch;\n  justify-content: space-between;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item:hover {\n  background: #f1f2f3;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item.active {\n  background: #f2f7fe;\n  position: relative;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__menu-item.active::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -8px;\n  border-radius: 0px 4px 4px 0px;\n  background: #2c6ecb;\n  width: 3px;\n  height: 100%;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__content {\n  flex: 1;\n  height: 100%;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__content > div {\n  height: 100%;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-page-templates__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-theme-setting-layout-modal .BC-theme-setting-layout-modal__content .Polaris-Tabs__Panel {\n  height: calc(100% - 53px);\n}\n\n.BC-theme-setting-layout-modal .Polaris-Tabs__Panel .Polaris-Card__Section {\n  padding: 1.25rem 1.25rem;\n  height: 100%;\n  overflow: auto;\n}\n\n.btn-group-polaris .Polaris-ButtonGroup__Item {\n  margin-left: 10px;\n}\n\n/* Preview theme setting overwrite css */\n.boost-sd__filter-option-content-inner,\n.boost-sd__sorting-button,\n/* .boost-sd__pagination, */\n.boost-sd__search-form-input,\n.boost-sd__search-form .boost-sd__button,\n.boost-sd__filter-tree-toggle-button {\n  pointer-events: none;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar {\n  display: flex;\n  width: 52px;\n  height: 100%;\n  padding: 6px 20px;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  border-right: 1px solid #e1e3e5;\n  background: #fff;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item {\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item:hover,\n.theme-setting-visual-editor .visual-editor-body .visual-editor-sidebar__item.active {\n  background: #f1f2f3;\n}\n\n.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-PositionedOverlay {\n  z-index: 520;\n}\n\n.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen {\n  max-width: 1164px;\n  height: calc(100vh - 3.75rem);\n}\n\n.BC-ThemeSetting-Editor-Page.theme-setting-visual-editor\n  ~ #PolarisPortalsContainer\n  .Polaris-Modal-Dialog--sizeLarge.Polaris-Modal-Dialog--fullScreen\n  .Polaris-Modal__Body\n  > .Polaris-Modal-Section {\n  height: 100%;\n  padding: 0;\n}\n\n.BC-theme-setting-page-templates {\n  padding: 20px;\n}\n\n.BC-theme-setting-page-templates .BC-theme-setting-page-templates__title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 8px;\n}\n\n.BC-theme-setting-page-templates .BC-theme-setting-page-templates__desc {\n  color: #6d7175;\n  margin-bottom: 20px;\n}\n\n.BC-theme-setting-page-templates__search .BC-theme-setting-page-templates__search-input {\n  display: flex;\n  padding: 8px 12px;\n  align-items: center;\n  align-self: stretch;\n  border-radius: 4px;\n  border: 1px solid #c9cccf;\n  background: #fff;\n}\n\n.BC-theme-setting-page-templates__search .BC-theme-setting-page-templates__search-input.focused {\n  border-color: #1a1a1a;\n  border-width: 0.0625rem;\n  background-color: #f7f7f7;\n  outline: 0.125rem solid #005bd3;\n  outline-offset: 0.0625rem;\n}\n\n.BC-theme-setting-page-templates__search\n  .BC-theme-setting-page-templates__search-input\n  .Polaris-TextField__Input {\n  padding: 0;\n  padding-left: 8px;\n  height: 20px;\n  min-height: unset;\n}\n\n.BC-theme-setting-page-templates__content {\n  margin-top: 12px;\n  height: calc(100% - 142px);\n}\n\n.BC-theme-setting-page-templates__content .BC-theme-setting-page-templates__content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-theme-setting-page-templates__content-header\n  .BC-Select__control {\n  width: 140px;\n}\n\n.BC-theme-setting-page-templates__content .BC-theme-setting-page-templates__content-body {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  column-gap: 20px;\n  row-gap: 24px;\n  margin-top: 20px;\n  overflow: auto;\n  height: calc(100% - 56px);\n  position: relative;\n}\n\n.BC-theme-setting-page-templates__content .BC-theme-setting-page-templates__content-body.chrome {\n  margin-right: -4px;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-theme-setting-page-templates__content-body.firefox-mac {\n  margin-right: -16px;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-theme-setting-page-templates__content-body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-theme-setting-page-templates__content-body::-webkit-scrollbar-thumb {\n  background: #cccccc;\n  border-radius: 4px;\n}\n\n.BC-theme-setting-page-templates__no-result {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.BC-theme-setting-page-templates__no-result .Polaris-Icon,\n.BC-theme-setting-page-templates__no-result .Polaris-Icon__Svg {\n  width: 60px;\n  height: 60px;\n}\n\n.BC-theme-setting-page-templates__no-result .title {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.BC-theme-setting-page-templates__content .BC-template-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  width: 220px;\n}\n\n.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__thumbnail {\n  border-radius: 8px;\n  /* box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.20); */\n  height: 200px;\n  width: 100%;\n  position: relative;\n}\n\n.BC-theme-setting-page-templates__content .BC-template-item.active .BC-template-item__thumbnail {\n  border-radius: 8px;\n  border: 2px solid #2c6ecb;\n  position: relative;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-template-item.active\n  .BC-template-item__thumbnail\n  .BC-template-item__selected-tag {\n  display: flex;\n  padding: 6px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 2px 8px;\n  background: #2c6ecb;\n  position: absolute;\n  top: 0;\n  right: -2px;\n  font-size: 12px;\n  color: #fff;\n}\n\n.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__thumbnail img {\n  height: 100%;\n}\n\n.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__thumbnail .overlay {\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.15s all ease-in-out;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  gap: 10px;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-template-item\n  .BC-template-item__thumbnail:hover\n  .overlay {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);\n  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);\n  opacity: 1;\n  visibility: visible;\n}\n\n.BC-theme-setting-page-templates__content\n  .BC-template-item\n  .BC-template-item__thumbnail\n  .overlay\n  .Polaris-Button {\n  width: 107px;\n  padding: 7px 12px;\n}\n\n.BC-theme-setting-page-templates__content .BC-template-item .BC-template-item__name {\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.BC-preview-template {\n  width: 100%;\n  height: 100%;\n}\n\n.BC-preview-template .BC-preview-template__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  width: 100%;\n  border-radius: 8px 8px 0px 0px;\n  background: #fff;\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n  position: relative;\n  height: 56px;\n}\n\n.BC-preview-template .BC-preview-template__header-mid .Polaris-Tabs__Tab {\n  width: 56px;\n  height: 56px;\n  padding: 0;\n}\n\n.BC-preview-template\n  .BC-preview-template__header-mid\n  .Polaris-Tabs__Tab--selected\n  .Polaris-Tabs__Title::before {\n  background: #44474a;\n  bottom: -7.5px;\n  border-radius: 0;\n  height: 2px;\n}\n\n.BC-preview-template .BC-preview-template__header-right .Polaris-Button {\n  width: 69px;\n  padding: 7px 12px;\n}\n\n.BC-preview-template .BC-preview-template__header-left .btn-back {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n  text-transform: capitalize;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.BC-preview-template .BC-preview-template__header-mid {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n\n.BC-preview-template__body {\n  width: 100%;\n  background: #f3f5f6;\n  text-align: center;\n  height: calc(100% - 56px);\n  overflow: auto;\n}\n\n.BC-preview-template__body img {\n  max-width: 100%;\n}\n\n/* New theme setting */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
